import React, { forwardRef } from 'react';

const cardStyle = {
    backgroundColor: 'var(--surface-raised)',
    borderRadius: 'var(--radius-lg)',
    border: '1px solid var(--border)',
    boxShadow: 'var(--shadow-sm)',
    color: 'var(--text)',
    fontFamily: 'var(--font-ui)',
    overflow: 'hidden',
    boxSizing: 'border-box'
};

const cardHeaderStyle = {
    padding: '1.25rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.375rem'
};

const cardTitleStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    lineHeight: '1.25',
    color: 'var(--text)',
    fontFamily: 'var(--font-display)'
};

const cardDescriptionStyle = {
    fontSize: '0.875rem',
    color: 'var(--text-muted)',
    lineHeight: '1.4'
};

const cardContentStyle = {
    padding: '0 1.5rem 1.5rem'
};

const cardFooterStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '0 1.5rem 1.25rem'
};

const Card = forwardRef(({ className, style, variant = 'default', ...props }, ref) => {
    const variantStyles = variant === 'sunken'
        ? { backgroundColor: 'var(--surface-sunken)' }
        : {};

    return (
        <div
            ref={ref}
            className={className}
            style={{ ...cardStyle, ...variantStyles, ...style }}
            {...props}
        />
    );
});
Card.displayName = 'Card';

const CardHeader = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        className={className}
        style={{ ...cardHeaderStyle, ...style }}
        {...props}
    />
));
CardHeader.displayName = 'CardHeader';

const CardTitle = forwardRef(({ className, style, ...props }, ref) => (
    <h3
        ref={ref}
        className={className}
        style={{ ...cardTitleStyle, ...style }}
        {...props}
    />
));
CardTitle.displayName = 'CardTitle';

const CardDescription = forwardRef(({ className, style, ...props }, ref) => (
    <p
        ref={ref}
        className={className}
        style={{ ...cardDescriptionStyle, ...style }}
        {...props}
    />
));
CardDescription.displayName = 'CardDescription';

const CardContent = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        className={className}
        style={{ ...cardContentStyle, ...style }}
        {...props}
    />
));
CardContent.displayName = 'CardContent';

const CardFooter = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        className={className}
        style={{ ...cardFooterStyle, ...style }}
        {...props}
    />
));
CardFooter.displayName = 'CardFooter';

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent, cardStyle, cardTitleStyle };
export default Card;
